module.exports = __webpack_public_path__ + "img/w4.610531bd.png";